import { useCallback } from "react";

import { Select, type Option } from "@skilitics/designer-ui-components";

import { useLocaleOptions } from "../../../l10n/useLocaleOptions.ts";
import type { localeEffectBuilder } from "./localeEffectBuilder";

export const LocaleEffectEditor: typeof localeEffectBuilder.views.edit = ({ config: { locale }, onConfigChange }) => {
  const options = useLocaleOptions();

  const handleSelectedOptionChange = useCallback(
    (option: Option) => onConfigChange({ locale: option.value }),
    [onConfigChange],
  );

  return <Select options={options} value={locale ?? ""} onSelectedOptionChange={handleSelectedOptionChange} />;
};
